import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HearingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hearing"}/>
}
